import HorizontalDisplay from './HorizontalDisplay-container';

export default HorizontalDisplay;
